export class RowClickEvent<T> {
	context: T;
}
